import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

const S = {
  page: { minHeight: 'calc(100vh - 56px)', background: '#0f1115', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 16px', textAlign: 'center' },
  hero: { fontSize: 'clamp(36px, 6vw, 64px)', fontWeight: 900, lineHeight: 1.1, marginBottom: '16px', color: '#fff' },
  accent: { color: '#00e701' },
  sub: { fontSize: '18px', color: '#6b7280', marginBottom: '40px', maxWidth: '480px', lineHeight: 1.6 },
  btns: { display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '60px' },
  btnPrimary: { background: '#00e701', color: '#000', border: 'none', borderRadius: '10px', padding: '14px 32px', fontWeight: 800, fontSize: '16px', cursor: 'pointer', transition: 'filter 0.15s' },
  btnSec: { background: 'none', color: '#9ca3af', border: '1px solid #2a2d35', borderRadius: '10px', padding: '14px 32px', fontWeight: 600, fontSize: '16px', cursor: 'pointer' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', maxWidth: '680px', width: '100%' },
  card: { background: '#1a1d24', borderRadius: '12px', padding: '24px', border: '1px solid #2a2d35', textAlign: 'left' },
  cardIcon: { fontSize: '28px', marginBottom: '12px' },
  cardTitle: { fontSize: '15px', fontWeight: 700, color: '#fff', marginBottom: '6px' },
  cardDesc: { fontSize: '13px', color: '#6b7280', lineHeight: 1.5 },
};

export default function Home() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div style={S.page}>
      <div style={S.hero}>
        Find the <span style={S.accent}>gems</span>,<br />dodge the mines.
      </div>
      <div style={S.sub}>
        Classic Mines game with Robux. Pick tiles, build your multiplier, cash out before you hit a mine.
      </div>
      <div style={S.btns}>
        <button style={S.btnPrimary} onClick={() => navigate(user ? '/game' : '/auth')}>
          {user ? 'Play Now' : 'Start Playing'}
        </button>
        {!user && (
          <button style={S.btnSec} onClick={() => navigate('/auth')}>
            Sign In
          </button>
        )}
        {user && (
          <button style={S.btnSec} onClick={() => navigate('/deposit')}>
            Deposit
          </button>
        )}
      </div>

      <div style={S.grid}>
        <div style={S.card}>
          <div style={{ ...S.cardIcon, color: '#00e701' }}>◆</div>
          <div style={S.cardTitle}>Provably Fair</div>
          <div style={S.cardDesc}>Every game uses a seeded random algorithm. Verify any result.</div>
        </div>
        <div style={S.card}>
          <div style={{ ...S.cardIcon, color: '#00e701' }}>⚡</div>
          <div style={S.cardTitle}>Instant Payouts</div>
          <div style={S.cardDesc}>Cash out anytime. Winnings credited to your balance immediately.</div>
        </div>
        <div style={S.card}>
          <div style={{ ...S.cardIcon, color: '#00e701' }}>★</div>
          <div style={S.cardTitle}>₿10 Signup Bonus</div>
          <div style={S.cardDesc}>New accounts get ₿10.00 free bonus to try the game instantly.</div>
        </div>
      </div>
    </div>
  );
}